import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  type TireInventory,
  type TireInventoryResponse,
} from 'types/tire-inventory.types';
import { type RootState } from './index';

export interface TireInventoryState {
  tireInventory: TireInventory[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  isLoading: boolean;
  isLoaded: boolean;
}

const initialState: TireInventoryState = {
  tireInventory: [],
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 0,
  isLoading: false,
  isLoaded: false,
};

export const tireInventorySlice = createSlice({
  name: 'tireInventory',
  initialState,
  reducers: {
    setTireInventory: (state, action: PayloadAction<TireInventoryResponse>) => {
      state.tireInventory = action.payload.data;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.limit = action.payload.limit;
      state.totalPages = action.payload.totalPages;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    resetTireInventory: (state) => {
      state.tireInventory = [];
      state.total = 0;
      state.page = 1;
      state.limit = 10;
      state.totalPages = 0;
      state.isLoading = false;
      state.isLoaded = false;
    },
  },
});

export const {
  setTireInventory,
  setIsLoading,
  setIsLoaded,
  resetTireInventory,
} = tireInventorySlice.actions;

export const selectTireInventory = (state: RootState) =>
  state.tireInventoryReducer;

export default tireInventorySlice.reducer;
